export default "__VITE_ASSET__BP7htQ7A__"